import React, {FC, useCallback, useState} from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { toast } from 'react-toastify';
import { useHistory } from 'react-router-dom';
// custom
import NavbarAdmin from '../../../../components/navbar/Navbar.admin';
import PaymentAdminForm, { PaymentFormData } from '../../../../components/forms/payments/Payment.admin.form';
import { IUserState } from '../../../../common/state/profile/user';
import { postPaymentAdmin } from '../../../../common/async/AsyncCalls';
// custom

const PaymentCreateAdmin : FC = () => {
    const history = useHistory();    
    // states    
    const token: string = useSelector(({user} : {user: IUserState}) => user.token);
    // lifecycle
    const postNewPayment = useCallback(async(formData: PaymentFormData)=>{
        // console.log('Create new payment record', formData);
        try {
            await postPaymentAdmin(token, {
                amount: formData.amount,
                currency: formData.currency,                
                description: formData.description                
            });
            toast("Payment record created successfully!");
            history.push({pathname: '/admin/payments'});
        } catch (err) {
            console.log('Error posting new payment recrod: ', (err as Error).message);
        }
    },[token]);

    return <React.Fragment>
        <NavbarAdmin/>
        <div
            className="w-screen p-4 lg:p-16 min-h-screen bg-gray-200 dark:bg-gray-800
                text-gray-700  dark:text-teal-400 flex flex-col justify-start items-start">
            <h2 className="text-gray-700 dark:text-teal-400 text-2xl mb-2">Create New Payment Record</h2>
            <p className="text-gray-700 dark:text-gray-300 dartext-base mb-4">
                Please fill out the below form to create a new Payment record. 
                Please note that the fields marked with * are required.                
            </p>
            <PaymentAdminForm defaultFormData={{
                amount: 0.00,
                description: '',
                currency: 'usd', 
            }}
            type = 'create' 
            onSubmit={postNewPayment}/>
        </div>
    </React.Fragment>;
};

export default PaymentCreateAdmin;